import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetAllLinhaProdutoResponse } from '../../responses/produto/get-all-linha-produto.response';
import { GetLinhaProdutoResponse } from '../../responses/produto/get-linha-produto.response';
import { LinhaProdutoBulkDeleteRequest, LinhaProdutoRequest } from '../../requests/produto/linha-produto.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class LinhaProdutoService extends CommonService {
    constructor(private httpClient: HttpClient) {
        super();
    }

    private readonly apiUrl = `${environment.urlApiProduto}linhaproduto`;

    /**
     * Lista paginada de linhas de produto.
     */
    public getAll(descricao: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetAllLinhaProdutoResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<GetAllLinhaProdutoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Busca uma linha de produto por ID.
     */
    public getById(idLinhaProduto: number): Observable<GetLinhaProdutoResponse> {
        const url = `${this.apiUrl}/${idLinhaProduto}`;
        return this.httpClient
            .get<GetLinhaProdutoResponse>(url, { ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Cria uma nova linha de produto.
     */
    public create(request: LinhaProdutoRequest): Observable<GetLinhaProdutoResponse> {
        return this.httpClient
            .post<GetLinhaProdutoResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Atualiza uma linha de produto existente.
     */
    public update(idLinhaProduto: number, request: LinhaProdutoRequest): Observable<GetLinhaProdutoResponse> {
        const url = `${this.apiUrl}/${idLinhaProduto}`;
        return this.httpClient
            .put<GetLinhaProdutoResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Exclusão lógica de uma linha de produto.
     */
    public delete(idLinhaProduto: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idLinhaProduto}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Exclusão lógica em lote.
     */
    public deleteBulk(idsLinhaProduto: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        const body: LinhaProdutoBulkDeleteRequest = { idsLinhaProduto };
        return this.httpClient
            .post<ReturnStruct>(url, body, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
